import React from 'react';
import { Grid, Typography } from '@material-ui/core'
import _ from 'lodash';

function getModalStyle() {

  return {
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
  };
}

const NewTextModal = (props) => {
  const modalClasses = props.modalClasses
  const [modalStyle] = React.useState(getModalStyle);
  const {texts} = props;

  // NOTE // text object example
  // accountSid: "AC6418b6e9a07650ebead3ff7a4e1ae0cc"
  // body: "Hello 9"
  // from: "+12088903265"
  // messageSid: "SMe769e053d643e3d106f25c978c8a12dd"
  // new: true
  // outbound: false
  // rloc: "AAAAPW"
  // timestamp: 1639520844866
  // to: "+18304335525"
  // __v: 0
  // _id: "61b91a4cfa2e7a77a9e33892"

  return (
    <div style={modalStyle} className={modalClasses.paperBasic}>
      <h2 id="simple-modal-title">New Texts from {texts[0].from}</h2>
      {!!texts.length ? texts.map((text, index) => {
        return index % 2 ? (
          <Grid className={modalClasses.bg0} item xs={12}>
            <Typography>{text.body}</Typography>
          </Grid>
        ) : 
        (
          <Grid className={modalClasses.bg1 + index%2} item xs={12}>
            <Typography>{text.body}</Typography>
          </Grid>
        )
      }) : 'Loading'}
    </div>
  )
};

export default NewTextModal;